import React, { useCallback, useEffect } from "react";
import { useRecoilCallback, useRecoilState, useRecoilValue } from "recoil";
import { useBoard } from "../hooks/useBoard";
import { useHints } from "../hooks/useHints";
import { useHistory } from "../hooks/useHistory";
import { useMouse } from "../hooks/useMouse";
import { BoardCellAtomFamily, IsGridHiddenAtom, MetaMatrixAtom, WorkingBoardAtom } from "../utils/context";
import { cssClasses } from "../utils/cssClasses";
import { Matrix } from "../utils/Matrix";
import { GameBoard } from "./GameBoard";
import { HintNumbers } from "./HintNumbers";
import { gameControllerStyles } from "./styles";
export var MemoBoard = React.memo(GameBoard);
export var MemoHintNumbers = React.memo(HintNumbers);
export function GameController(_a) {
    var onRefresh = _a.onRefresh;
    var metaMatrix = useRecoilValue(MetaMatrixAtom);
    var _b = useRecoilState(IsGridHiddenAtom), isGridHidden = _b[0], setGridHidden = _b[1];
    var _c = useBoard(), resetBoard = _c.resetBoard, currentBoard = _c.currentBoard, updateCurrentBoard = _c.updateCurrentBoard;
    var getProgress = useHints().getProgress;
    var _d = useHistory(), resetHistory = _d.resetHistory, cleanHistory = _d.cleanHistory, undoAction = _d.undoAction, redoAction = _d.redoAction, canUndo = _d.canUndo, canRedo = _d.canRedo;
    var _e = useMouse(), onMouseDown = _e.onMouseDown, onMouseUp = _e.onMouseUp, mouseButton = _e.mouseButton, mouseSquareValue = _e.mouseSquareValue, lastMousePosition = _e.lastMousePosition, onSquareMouseEnter = _e.onSquareMouseEnter, onSquareMouseLeave = _e.onSquareMouseLeave;
    var onBoardMouseUp = useCallback(function (event) {
        onMouseUp(event);
        cleanHistory();
        updateCurrentBoard();
    }, [onMouseUp, updateCurrentBoard]);
    var onBoardMouseDown = useCallback(function (event) {
        onMouseDown(event);
    }, [onMouseDown]);
    var updateSquare = useRecoilCallback(function (_a) {
        var set = _a.set;
        return function () {
            if (lastMousePosition && mouseButton !== "none") {
                set(BoardCellAtomFamily(lastMousePosition.index), mouseSquareValue);
                set(WorkingBoardAtom, function (matrix) {
                    return matrix.setAt(lastMousePosition.index, mouseSquareValue);
                });
            }
        };
    }, [mouseButton, lastMousePosition]);
    useEffect(function () {
        updateSquare();
    }, [updateSquare]);
    useEffect(function () {
        onRefresh({
            canUndo: canUndo,
            canRedo: canRedo,
            setGridHidden: setGridHidden,
            undo: undoAction,
            redo: redoAction,
            restart: resetHistory,
            nextState: function (grid) {
                resetBoard(new Matrix(grid, metaMatrix));
            },
            getProgress: getProgress,
            getCurrentBoard: function () { return currentBoard.values; }
        });
    }, [
        onRefresh,
        canUndo,
        canRedo,
        setGridHidden,
        undoAction,
        redoAction,
        resetHistory,
        resetBoard,
        getProgress,
        currentBoard
    ]);
    return (React.createElement("div", { onContextMenu: function (e) { return e.preventDefault(); }, className: cssClasses(gameControllerStyles, isGridHidden && "hide-grid") },
        React.createElement("div", { className: "area-col-hints" },
            React.createElement(MemoHintNumbers, { lineType: "col" })),
        React.createElement("div", { className: "area-row-hints" },
            React.createElement(MemoHintNumbers, { lineType: "row" })),
        React.createElement("div", { className: "area-board" },
            React.createElement(MemoBoard, { metaMatrix: metaMatrix, onBoardMouseUp: onBoardMouseUp, onBoardMouseDown: onBoardMouseDown, onBoardMouseLeave: onBoardMouseUp, onSquareMouseEnter: onSquareMouseEnter, onSquareMouseLeave: onSquareMouseLeave }))));
}
